import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Line } from '@ant-design/charts';
import { Spin } from 'antd';

function LineGrafic({
  data = [],
  width = 800,
  height = 400,
  loading = false,
  style,
  xField = 'label',
  yField = 'value',
}) {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef && chartRef.current) {
      const chart = chartRef.current.getChart();
      chart.changeSize(width, height);
    }
  }, [width, height]);

  const config = {
    data,
    width,
    height,
    autoFit: false,
    xField,
    yField,
    point: {
      size: 5,
      shape: 'diamond',
    },
    label: {
      style: {
        fill: '#aaa',
      },
    },
  };

  return (
    <div style={{ ...style }}>
      {loading ? (
        <div
          style={{
            width,
            height,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin />
        </div>
      ) : (
        <Line
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...config}
          ref={chartRef}
          loading={loading}
        />
      )}
    </div>
  );
}

LineGrafic.propTypes = {
  data: PropTypes.arrayOf(),
  width: PropTypes.number,
  height: PropTypes.number,
  loading: PropTypes.bool,
  style: PropTypes.shape(),
  xField: PropTypes.string,
  yField: PropTypes.string,
};

LineGrafic.defaultProps = {
  data: [],
  width: 800,
  height: 400,
  loading: false,
  style: {},
  xField: 'label',
  yField: 'value',
};

export default LineGrafic;
